import { Database } from '../../adapters/database'
import { DexieDbUtils } from '../../utils/libs/dexieDbUtils'
const DBUtils = DexieDbUtils

class UserRepo {
  constructor(dbInstance) {
    this.dbInstance = dbInstance
  }

  static async getDb() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    let db = self.repositories?.userRepo
    if (!db) {
      db = await UserRepo.init()
      self.repositories.userRepo = db
    }
    return db
  }

  static async init() {
    const db = new Database()
    await db.init(DBUtils, 'user')
    if (!db) return null
    return new UserRepo(db)
  }

  async get() {
    const [user] = await this.dbInstance.find()
    return user
  }

  async save(data) {
    await this.dbInstance.save(data)
  }

  async clean() {
    await this.dbInstance.deleteAll()
  }
}

export { UserRepo }
